import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {CommonModule} from '@angular/common';
import {FormAnnotationBoxComponent} from './form-annotation-box/form-annotation-box.component';
import {RadioBtnsComponent} from './radio-btns/radio-btns/radio-btns.component';
import {RadioBtnsFormItemComponent} from './radio-btns/radio-btns-form-item/radio-btns-form-item.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {GlobalSpinnerComponent} from './global-spinner/global-spinner.component';
import {CheckboxComponent} from './checkbox/checkbox/checkbox.component';
import {CheckboxFormItemComponent} from './checkbox/checkbox-form-item/checkbox-form-item.component';
import {FormWrapperComponent} from './form-wrapper/form-wrapper.component';
import {GlobalStylingComponent} from './global-styling/global-styling.component';
import {ButtonComponent} from './button/button.component';
import {InputComponent} from './input/input/input.component';
import {InputFormItemComponent} from './input/input-form-item/input-form-item.component';

@NgModule({
  imports: [
    BrowserModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    // NgSelectModule,
    // AgGridModule
  ],
  declarations: [
    FormAnnotationBoxComponent,
    RadioBtnsComponent,
    RadioBtnsFormItemComponent,
    GlobalSpinnerComponent,
    CheckboxComponent,
    CheckboxFormItemComponent,
    FormWrapperComponent,
    ButtonComponent,
    InputComponent,
    InputFormItemComponent,
    // SelectComponent,
    // GridComponent,
    GlobalStylingComponent
  ],
  exports: [
    FormAnnotationBoxComponent,
    RadioBtnsComponent,
    RadioBtnsFormItemComponent,
    GlobalSpinnerComponent,
    CheckboxComponent,
    CheckboxFormItemComponent,
    FormWrapperComponent,
    ButtonComponent,
    InputComponent,
    InputFormItemComponent
    // SelectComponent,
    //  GridComponent
  ]
})
export class Li3WidgetsModule {
}
